import { useCallback, useMemo } from 'react';

import { type EAccessCheckTrackingStatus } from '@/packages/EarlyAccessPaywall/shared/components/Provider/Provider';

import { useCAForCard } from '../../../hooks/card/useCAForCard';

type TTracking = {
  trackSendMessage: (isEarlyAccess?: boolean) => void;
  trackMessagePopupOpen: (isEarlyAccess?: boolean) => void;
  trackEarlyAccessBlocked: (trackingStatus: EAccessCheckTrackingStatus) => void;
};

export const useChatTracking = (): TTracking => {
  const ca = useCAForCard();

  const trackSendMessage = useCallback(
    (isEarlyAccess: boolean = false) => {
      ca(
        { action: 'send_message', category: 'Listing' },
        { label: true, pageExtra: { is_early_access: isEarlyAccess } },
      );
    },
    [ca],
  );

  const trackMessagePopupOpen = useCallback(
    (isEarlyAccess: boolean = false) => {
      ca({ action: 'open', category: 'Message_popup' }, { label: true, pageExtra: { is_early_access: isEarlyAccess } });
    },
    [ca],
  );

  const trackEarlyAccessBlocked = useCallback(
    (trackingStatus: EAccessCheckTrackingStatus) => {
      ca(
        { category: 'Listing', action: 'send_message_blocked_early_access' },
        { label: true, pageExtra: { block_type: trackingStatus } },
      );
    },
    [ca],
  );

  return useMemo(
    () => ({
      trackSendMessage,
      trackMessagePopupOpen,
      trackEarlyAccessBlocked,
    }),
    [trackEarlyAccessBlocked, trackMessagePopupOpen, trackSendMessage],
  );
};
